import $ from 'jquery';
import { postRequests } from '@/service/requests';

export default class FreshDeskService {
  constructor({ apiKeyPlusPass, domain }) {
    this.url = `https://${domain}/api/v2/tickets`;
    this.headers = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${btoa(apiKeyPlusPass)}`
    };
  }
  sendTicket({
    description,
    email,
    type,
    name,
    priority,
    subject,
    onSuccess,
    onError,
    onFinally
  }) {
    const data = {
      description: description,
      subject: `[${subject}] Contact Us Page Ticket`,
      email: email,
      type: type,
      name: name,
      priority: priority,
      status: 2
    };
    const config = {
      headers: this.headers
    };
    postRequests(this.url, data, config)
      .then((datRes) => {
        console.log('Ticket created successfully:', datRes);
        if (datRes.error) {
          onError();
        } else {
          onSuccess();
        }
      })
      .finally(() => {
        onFinally();
      });
  }
}
